import React, { useState } from 'react';
import './SpecialistAdsManagePage.css';

const SpecialistAdsManagePage = () => {
  const [selectedPosition, setSelectedPosition] = useState('Buyer Directory page');
  const [showPositionDropdown, setShowPositionDropdown] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date(2025, 5, 1)); // June 2025
  const [formData, setFormData] = useState({
    link: '',
    fromDate: '',
    toDate: ''
  });
  
  const [uploadedImages, setUploadedImages] = useState([
    { id: 1, url: '/uploads/builder-images/15d28837d41cb5d88e7a660e05cc186b01c4521f_w506.png', size: '285x295 px' },
    { id: 2, url: '/uploads/builder-images/da6224fffbcfdfa16939a189673dc08057f05723_w854.png', size: '285x535 px' }
  ]);

  const adsPrices = [
    { name: 'Buy Leads Page Sponsor', price: '$30' },
    { name: 'Home page hero section', price: '$30' },
    { name: 'Home page Second middle section', price: '$30' },
    { name: 'Category page', price: '$30' },
    { name: 'Buyer Directory page', price: '$30' }
  ];

  const adsPricesRight = [
    { name: 'Home page first middle section', price: '$30' },
    { name: 'Home page footer section', price: '$30' },
    { name: 'Product page', price: '$30' },
    { name: 'Supplier page', price: '$30' },
    { name: 'News page', price: '$30' }
  ];

  const positionOptions = [
    'Buy Leads page',
    'Buy Leads Page Sponsor',
    'Home page hero section',
    'Home page Second middle section',
    'Home page first middle section',
    'Home page footer section',
    'Category page',
    'Buyer Directory page'
  ];

  const handleEditImage = (id) => {
    // Handle image edit
    console.log('Edit image:', id);
  };

  const handleDeleteImage = (id) => {
    setUploadedImages(uploadedImages.filter(img => img.id !== id));
  };

  const sidebarMenuItems = [
    { id: 'dashboard', icon: 'home', label: 'Dashboard', active: false },
    { id: 'projects', icon: 'list', label: 'Project Lists', active: false, hasSubmenu: true },
    { id: 'rfq', icon: 'bell', label: 'RFQ Manage', active: false, hasSubmenu: true },
    { id: 'messages', icon: 'chat', label: 'Inqs / Msgs', active: false, hasSubmenu: true },
    { id: 'membership', icon: 'membership', label: 'Membership Plan', active: false, hasSubmenu: true },
    { id: 'ads', icon: 'ads', label: ' Ads Manage', active: true, hasSubmenu: true },
    { id: 'profile', icon: 'user', label: 'Specialist Profile', active: false }
  ];

  // Calendar data
  const bookedDates = [4, 12, 19, 25, 26, 27, 28];
  
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDay = firstDay.getDay();
    
    return { daysInMonth, startingDay };
  };

  const getMonthName = (date) => {
    return date.toLocaleDateString('en-US', { month: 'long' });
  };

  const navigateMonth = (direction) => {
    setCurrentMonth(prev => {
      const newDate = new Date(prev);
      newDate.setMonth(prev.getMonth() + direction);
      return newDate;
    });
  };

  const goToToday = () => {
    setCurrentMonth(new Date(2025, 5, 1)); // June 2025
  };

  const renderCalendar = () => {
    const { daysInMonth, startingDay } = getDaysInMonth(currentMonth);
    const weeks = [];
    let days = [];
    
    // Previous month days
    const prevMonth = new Date(currentMonth);
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    const prevMonthDays = new Date(prevMonth.getFullYear(), prevMonth.getMonth() + 1, 0).getDate();
    
    // Add empty cells for days before the first day of month
    for (let i = 0; i < startingDay; i++) {
      days.push(
        <div key={`prev-${i}`} className="calendar-day other-month">
          <span className="day-number">{prevMonthDays - startingDay + i + 1}</span>
        </div>
      );
    }
    
    // Add days of current month
    for (let day = 1; day <= daysInMonth; day++) {
      const isBooked = bookedDates.includes(day);
      const isToday = day === 16;
      
      days.push(
        <div key={day} className={`calendar-day ${isBooked ? 'booked' : ''} ${isToday ? 'today' : ''}`}>
          <span className="day-number">
            {day === 1 ? `${getMonthName(currentMonth).substring(0, 3)} 1` : day}
          </span>
          {isBooked && <span className="booked-label">Booked</span>}
        </div>
      );
      
      if ((startingDay + day) % 7 === 0 || day === daysInMonth) {
        weeks.push(
          <div key={`week-${weeks.length}`} className="calendar-week">
            {days}
          </div>
        );
        days = [];
      }
    }
    
    // Add next month days to complete the last week
    const remainingDays = 7 - days.length;
    if (days.length > 0 && remainingDays < 7) {
      for (let i = 1; i <= remainingDays; i++) {
        days.push(
          <div key={`next-${i}`} className="calendar-day other-month">
            <span className="day-number">{i === 1 ? 'Jul 1' : i}</span>
          </div>
        );
      }
      weeks.push(
        <div key={`week-${weeks.length}`} className="calendar-week">
          {days}
        </div>
      );
    }
    
    return weeks;
  };

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'home':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 22V12H15V22" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'list':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.25 7C3.25 6.80109 3.32902 6.61032 3.46967 6.46967C3.61032 6.32902 3.80109 6.25 4 6.25H20C20.1989 6.25 20.3897 6.32902 20.5303 6.46967C20.671 6.61032 20.75 6.80109 20.75 7C20.75 7.19891 20.671 7.38968 20.5303 7.53033C20.3897 7.67098 20.1989 7.75 20 7.75H4C3.80109 7.75 3.61032 7.67098 3.46967 7.53033C3.32902 7.38968 3.25 7.19891 3.25 7ZM3.25 12C3.25 11.8011 3.32902 11.6103 3.46967 11.4697C3.61032 11.329 3.80109 11.25 4 11.25H15C15.1989 11.25 15.3897 11.329 15.5303 11.4697C15.671 11.6103 15.75 11.8011 15.75 12C15.75 12.1989 15.671 12.3897 15.5303 12.5303C15.3897 12.671 15.1989 12.75 15 12.75H4C3.80109 12.75 3.61032 12.671 3.46967 12.5303C3.32902 12.3897 3.25 12.1989 3.25 12ZM3.25 17C3.25 16.8011 3.32902 16.6103 3.46967 16.4697C3.61032 16.329 3.80109 16.25 4 16.25H9C9.19891 16.25 9.38968 16.329 9.53033 16.4697C9.67098 16.6103 9.75 16.8011 9.75 17C9.75 17.1989 9.67098 17.3897 9.53033 17.5303C9.38968 17.671 9.19891 17.75 9 17.75H4C3.80109 17.75 3.61032 17.671 3.46967 17.5303C3.32902 17.3897 3.25 17.1989 3.25 17Z" fill="#505050"/>
          </svg>
        );
      case 'bell':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.7295 21C13.5537 21.3031 13.3014 21.5547 12.9978 21.7295C12.6941 21.9044 12.3499 21.9965 11.9995 21.9965C11.6492 21.9965 11.3049 21.9044 11.0013 21.7295C10.6977 21.5547 10.4453 21.3031 10.2695 21" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'chat':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 7.5H17.25V4.5C17.25 4.10218 17.092 3.72064 16.8107 3.43934C16.5294 3.15804 16.1478 3 15.75 3H3.75C3.35218 3 2.97064 3.15804 2.68934 3.43934C2.40804 3.72064 2.25 4.10218 2.25 4.5V16.5C2.25044 16.6411 2.29068 16.7792 2.36608 16.8985C2.44149 17.0177 2.54901 17.1133 2.67629 17.1742C2.80358 17.2351 2.94546 17.2589 3.08564 17.2428C3.22581 17.2266 3.3586 17.1713 3.46875 17.0831L6.75 14.4375V17.25C6.75 17.6478 6.90804 18.0294 7.18934 18.3107C7.47064 18.592 7.85218 18.75 8.25 18.75H17.0241L20.5312 21.5831C20.664 21.6905 20.8293 21.7493 21 21.75C21.1989 21.75 21.3897 21.671 21.5303 21.5303C21.671 21.3897 21.75 21.1989 21.75 21V9C21.75 8.60218 21.592 8.22064 21.3107 7.93934C21.0294 7.65804 20.6478 7.5 20.25 7.5ZM6.23906 12.9169L3.75 14.9297V4.5H15.75V12.75H6.71063C6.53897 12.75 6.37252 12.8089 6.23906 12.9169ZM20.25 19.4297L17.7609 17.4169C17.6282 17.3095 17.4629 17.2507 17.2922 17.25H8.25V14.25H15.75C16.1478 14.25 16.5294 14.092 16.8107 13.8107C17.092 13.5294 17.25 13.1478 17.25 12.75V9H20.25V19.4297Z" fill="#333333"/>
          </svg>
        );
      case 'membership':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.625 18.5625H3C2.5526 18.562 2.12367 18.3841 1.80731 18.0677C1.49095 17.7513 1.313 17.3224 1.3125 16.875V4.875C1.3125 3.94463 2.06963 3.1875 3 3.1875H5.625C5.77418 3.1875 5.91726 3.24676 6.02275 3.35225C6.12824 3.45774 6.1875 3.60082 6.1875 3.75C6.1875 3.89918 6.12824 4.04226 6.02275 4.14775C5.91726 4.25324 5.77418 4.3125 5.625 4.3125H3C2.68988 4.3125 2.4375 4.56488 2.4375 4.875V16.875C2.4375 17.1851 2.68988 17.4375 3 17.4375H5.625C5.77418 17.4375 5.91726 17.4968 6.02275 17.6023C6.12824 17.7077 6.1875 17.8508 6.1875 18C6.1875 18.1492 6.12824 18.2923 6.02275 18.3977C5.91726 18.5032 5.77418 18.5625 5.625 18.5625ZM19.875 14.2875C19.7258 14.2875 19.5827 14.2282 19.4773 14.1227C19.3718 14.0173 19.3125 13.8742 19.3125 13.725V4.875C19.3125 4.56488 19.0601 4.3125 18.75 4.3125H16.125C15.9758 4.3125 15.8327 4.25324 15.7273 4.14775C15.6218 4.04226 15.5625 3.89918 15.5625 3.75C15.5625 3.60082 15.6218 3.45774 15.7273 3.35225C15.8327 3.24676 15.9758 3.1875 16.125 3.1875H18.75C19.6804 3.1875 20.4375 3.94463 20.4375 4.875V13.725C20.4375 13.8742 20.3782 14.0173 20.2727 14.1227C20.1673 14.2282 20.0242 14.2875 19.875 14.2875Z" fill="#333333"/>
            <path d="M11.25 20.4375H6.75C6.3026 20.437 5.87367 20.2591 5.55731 19.9427C5.24095 19.6263 5.063 19.1974 5.0625 18.75V3C5.0625 2.06963 5.81963 1.3125 6.75 1.3125H15C15.9304 1.3125 16.6875 2.06963 16.6875 3V13.3837C16.6875 13.5329 16.6282 13.676 16.5227 13.7815C16.4173 13.887 16.2742 13.9462 16.125 13.9462C15.9758 13.9462 15.8327 13.887 15.7273 13.7815C15.6218 13.676 15.5625 13.5329 15.5625 13.3837V3C15.5625 2.68988 15.3101 2.4375 15 2.4375H6.75C6.43988 2.4375 6.1875 2.68988 6.1875 3V18.75C6.1875 19.0601 6.43988 19.3125 6.75 19.3125H11.25C11.3992 19.3125 11.5423 19.3718 11.6477 19.4773C11.7532 19.5827 11.8125 19.7258 11.8125 19.875C11.8125 20.0242 11.7532 20.1673 11.6477 20.2727C11.5423 20.3782 11.3992 20.4375 11.25 20.4375Z" fill="#333333"/>
            <path d="M17.625 22.6875C14.8335 22.6875 12.5625 20.4165 12.5625 17.625C12.5625 14.8335 14.8335 12.5625 17.625 12.5625C20.4165 12.5625 22.6875 14.8335 22.6875 17.625C22.6875 20.4165 20.4165 22.6875 17.625 22.6875ZM17.625 13.6875C15.4538 13.6875 13.6875 15.4538 13.6875 17.625C13.6875 19.7963 15.4538 21.5625 17.625 21.5625C19.7963 21.5625 21.5625 19.7963 21.5625 17.625C21.5625 15.4538 19.7963 13.6875 17.625 13.6875Z" fill="#333333"/>
            <path d="M16.9681 19.687C16.819 19.687 16.676 19.6278 16.5706 19.5224L14.8831 17.8349C14.7777 17.7295 14.7185 17.5865 14.7185 17.4374C14.7185 17.2883 14.7777 17.1453 14.8831 17.0399C14.9885 16.9345 15.1315 16.8753 15.2806 16.8753C15.4297 16.8753 15.5727 16.9345 15.6781 17.0399L16.9681 18.3299L19.5731 15.7249C19.6785 15.6195 19.8215 15.5602 19.9706 15.5602C20.1198 15.5602 20.2628 15.6195 20.3681 15.7249C20.4735 15.8303 20.5328 15.9733 20.5328 16.1224C20.5328 16.2716 20.4735 16.4146 20.3681 16.5199L17.3656 19.5224C17.2602 19.6278 17.1172 19.687 16.9681 19.687Z" fill="#333333"/>
          </svg>
        );
      case 'ads':
        return (
          <img 
            src="/uploads/builder-images/e430665c10ca246f06995a7f1068092a4fdf9b5c_w48.png" 
            alt="Ads" 
            style={{ width: '24px', height: '24px' }}
          />
        );
      case 'user':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.002 2.12109C13.5074 2.12117 14.9715 2.61586 16.1689 3.52832C17.3662 4.44083 18.2306 5.72141 18.6299 7.17285C19.0292 8.62438 18.941 10.1669 18.3789 11.5635C17.8494 12.8787 16.9273 13.9958 15.7412 14.7646C18.231 15.6441 20.3602 17.3954 21.7568 19.8086L21.7988 19.8848C21.8368 19.9633 21.8628 20.0472 21.876 20.1338C21.8935 20.2492 21.888 20.3673 21.8594 20.4805C21.8306 20.5937 21.7795 20.7008 21.709 20.7939C21.6385 20.8871 21.5494 20.965 21.4482 21.0234C21.3473 21.0817 21.2358 21.1193 21.1201 21.1338C21.0042 21.1483 20.8859 21.1401 20.7734 21.1084C20.661 21.0767 20.5561 21.0221 20.4648 20.9492C20.3737 20.8764 20.2979 20.7861 20.2422 20.6836V20.6826C18.4975 17.67 15.4171 15.8741 12.002 15.874C8.5854 15.874 5.50418 17.6718 3.75977 20.6865L3.75879 20.6855C3.70317 20.7871 3.62857 20.8769 3.53809 20.9492C3.44681 21.0221 3.34193 21.0767 3.22949 21.1084C3.11718 21.14 2.99958 21.1482 2.88379 21.1338C2.76789 21.1193 2.65584 21.0818 2.55469 21.0234C2.45351 20.965 2.36445 20.8871 2.29395 20.7939C2.22347 20.7008 2.17326 20.5937 2.14453 20.4805C2.11586 20.3673 2.10941 20.2492 2.12695 20.1338C2.14015 20.0473 2.16615 19.9633 2.2041 19.8848L2.24609 19.8086C3.6427 17.3945 5.77202 15.6433 8.26172 14.7646C7.07569 13.9957 6.15346 12.8786 5.62402 11.5635C5.06189 10.1669 4.9738 8.62436 5.37305 7.17285C5.77242 5.72123 6.63747 4.44085 7.83496 3.52832C9.03246 2.61579 10.4964 2.12109 12.002 2.12109ZM13.001 3.97168C12.007 3.77407 10.9763 3.87584 10.04 4.26367C9.10367 4.65158 8.30333 5.30863 7.74023 6.15137C7.17711 6.99416 6.87695 7.98541 6.87695 8.99902C6.87854 10.3576 7.41827 11.6604 8.37891 12.6211C9.33974 13.5819 10.6431 14.1226 12.002 14.124C13.0154 14.124 14.006 13.8228 14.8486 13.2598C15.6914 12.6966 16.3484 11.8964 16.7363 10.96C17.1242 10.0236 17.226 8.9931 17.0283 7.99902C16.8306 7.00504 16.3425 6.09169 15.626 5.375C14.9092 4.65826 13.9951 4.16943 13.001 3.97168Z" fill="#333333" stroke="#333333" strokeWidth="0.25"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="specialist-ads-manage">
      {/* Header */}
      <header className="dashboard-header">
        <div className="header-content">
          <img 
            src="/logo.png?v=2" 
            alt="Conflux" 
            className="logo"
          />
          <div className="header-right">
            <div className="language-selector">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.58333 2.15234C7.93516 2.15234 6.32399 2.64109 4.95358 3.55676C3.58317 4.47244 2.51507 5.77393 1.88434 7.29665C1.25361 8.81936 1.08858 10.4949 1.41013 12.1114C1.73167 13.7279 2.52534 15.2128 3.69078 16.3782C4.85622 17.5437 6.34107 18.3373 7.95758 18.6589C9.57409 18.9804 11.2496 18.8154 12.7724 18.1847C14.2951 17.5539 15.5966 16.4858 16.5122 15.1154C17.4279 13.745 17.9167 12.1339 17.9167 10.4857C17.9141 8.27632 17.0353 6.15818 15.4731 4.59593C13.9108 3.03368 11.7927 2.15489 9.58333 2.15234ZM16.6042 9.84465H13.4127C13.2692 6.91917 12.1426 4.85026 11.2188 3.6267C12.6533 3.97118 13.944 4.756 14.9099 5.87111C15.8759 6.98621 16.4686 8.37567 16.605 9.84465H16.6042ZM7.03766 11.1267H12.129C11.9439 14.4608 10.3478 16.5041 9.58333 17.2966C8.81811 16.5033 7.22276 14.46 7.03766 11.1267ZM7.03766 9.84465C7.22276 6.51052 8.81891 4.46725 9.58333 3.67478C10.3486 4.47045 11.9439 6.51372 12.129 9.84465H7.03766ZM7.94792 3.6267C7.02404 4.85026 5.89744 6.91917 5.75401 9.84465H2.5617C2.69808 8.37567 3.29079 6.98621 4.25673 5.87111C5.22268 4.756 6.5134 3.97118 7.94792 3.6267ZM2.5617 11.1267H5.75401C5.89984 14.0522 7.02404 16.1211 7.94792 17.3446C6.5134 17.0002 5.22268 16.2153 4.25673 15.1002C3.29079 13.9851 2.69808 12.5957 2.5617 11.1267ZM11.2155 17.3446C12.1394 16.1211 13.2636 14.0522 13.4095 11.1267H16.6018C16.4656 12.5953 15.8733 13.9844 14.908 15.0995C13.9427 16.2145 12.6527 16.9996 11.2188 17.3446H11.2155Z" fill="#354556"/>
              </svg>
              <span>عربي</span>
            </div>
            <div className="user-profile">
              <div className="user-avatar"></div>
              <div className="user-info">
                <span className="user-name">Alek Gender</span>
                <span className="user-role">Sub Admin</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="dashboard-container">
        {/* Sidebar */}
        <aside className="dashboard-sidebar">
          <div className="sidebar-profile">
            <div className="profile-avatar-container">
              <div className="profile-avatar"></div>
              <button className="edit-avatar-btn">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="16" fill="#8AA5B4"/>
                  <path d="M16 24H23" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20.0389 9.34008C20.3642 9.01478 20.8054 8.83203 21.2654 8.83203C21.4932 8.83203 21.7188 8.8769 21.9292 8.96407C22.1397 9.05124 22.3309 9.17901 22.492 9.34008C22.653 9.50115 22.7808 9.69237 22.868 9.90282C22.9551 10.1133 23 10.3388 23 10.5666C23 10.7944 22.9551 11.02 22.868 11.2304C22.7808 11.4409 22.653 11.6321 22.492 11.7932L12.2708 22.0143L9 22.832L9.81769 19.5613L20.0389 9.34008Z" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="profile-info">
              <h3 className="profile-title">Architecture Engineer</h3>
            </div>
          </div>

          <nav className="sidebar-nav">
            {sidebarMenuItems.map((item) => (
              <div key={item.id} className={`nav-item ${item.active ? 'active' : ''}`}>
                <div className="nav-item-content">
                  {renderIcon(item.icon)}
                  <span>{item.label}</span>
                </div>
                {item.hasSubmenu && (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6L15 12L9 18" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </div>
            ))}
            <div className="nav-item logout">
              <div className="nav-item-content">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5 3.751C5.974 3.751 5.25 4.381 5.25 5.572V18.431C5.25 19.623 5.974 20.252 6.5 20.252H13.496C13.6949 20.252 13.8857 20.331 14.0263 20.4717C14.167 20.6123 14.246 20.8031 14.246 21.002C14.246 21.2009 14.167 21.3917 14.0263 21.5323C13.8857 21.673 13.6949 21.752 13.496 21.752H6.5C4.817 21.752 3.75 20.079 3.75 18.431V5.571C3.75 3.923 4.817 2.25 6.5 2.25H13.5C13.6989 2.25 13.8897 2.32902 14.0303 2.46967C14.171 2.61032 14.25 2.80109 14.25 3C14.25 3.19891 14.171 3.38968 14.0303 3.53033C13.8897 3.67098 13.6989 3.75 13.5 3.75L6.5 3.751Z" fill="#FF7474"/>
                  <path d="M16.53 7.97325C16.3894 7.8328 16.1988 7.75391 16 7.75391C15.8012 7.75391 15.6106 7.8328 15.47 7.97325V11.2492H9.5C9.30109 11.2492 9.11032 11.3283 8.96967 11.4689C8.82902 11.6096 8.75 11.8003 8.75 11.9992C8.75 12.1982 8.82902 12.3889 8.96967 12.5296C9.11032 12.6702 9.30109 12.7492 9.5 12.7492H15.47V16.0332C15.6106 16.1737 15.8012 16.2526 16 16.2526C16.1988 16.2526 16.3894 16.1737 16.53 16.0332L20.03 12.5332C20.0999 12.4634 20.1553 12.3805 20.1931 12.2892C20.2308 12.1979 20.2502 12.1 20.25 12.0012V11.9992C20.2499 11.8896 20.2258 11.7812 20.1793 11.6819C20.1329 11.5825 20.0652 11.4946 19.981 11.4242L16.53 7.97325Z" fill="#FF7474"/>
                </svg>
                <span>Logout</span>
              </div>
            </div>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="dashboard-main">
          <div className="page-header">
            <div className="page-title-section">
              <h1 className="page-title"> Ads Manage</h1>
              <p className="page-description">
                Promote your products and reach more buyers with targeted ads.
              </p>
            </div>
          </div>

          <div className="ads-content">
            {/* Ads Price Section */}
            <div className="ads-price-section">
              <h2 className="section-title">Ads Price</h2>
              <div className="ads-price-container">
                <div className="ads-price-columns">
                  <div className="price-column">
                    {adsPrices.map((item, index) => (
                      <div key={index} className={`price-item ${index === 0 ? 'with-border' : ''}`}>
                        <span className="price-label">{item.name}</span>
                        <span className="price-value">{item.price}</span>
                      </div>
                    ))}
                  </div>
                  <div className="price-column">
                    {adsPricesRight.map((item, index) => (
                      <div key={index} className="price-item">
                        <span className="price-label">{item.name}</span>
                        <span className="price-value">{item.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <button className="edit-price-btn">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 14.1172H15" stroke="#1F396C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12.2278 5.27796C12.4408 5.06497 12.7297 4.94531 13.0309 4.94531C13.1801 4.94531 13.3278 4.97469 13.4656 5.03177C13.6033 5.08884 13.7286 5.1725 13.834 5.27796C13.9395 5.38343 14.0231 5.50863 14.0802 5.64643C14.1373 5.78422 14.1667 5.93191 14.1667 6.08106C14.1667 6.2302 14.1373 6.37789 14.0802 6.51569C14.0231 6.65348 13.9395 6.77869 13.834 6.88415L7.14158 13.5766L5 14.112L5.53539 11.9704L12.2278 5.27796Z" stroke="#1F396C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Edit Price</span>
                </button>
              </div>
            </div>

            {/* Calendar Section */}
            <div className="calendar-section">
              <h2 className="section-title">Available date</h2>
              <div className="calendar-container">
                <div className="calendar-header">
                  <div className="calendar-title">
                    <span className="month-name">{getMonthName(currentMonth)}</span>
                    <span className="year">{currentMonth.getFullYear()}</span>
                  </div>
                  <div className="calendar-nav">
                    <button className="nav-btn" onClick={() => navigateMonth(-1)}>
                      <span>◀</span>
                    </button>
                    <button className="today-btn" onClick={goToToday}>
                      <span>Today</span>
                    </button>
                    <button className="nav-btn" onClick={() => navigateMonth(1)}>
                      <span>▶</span>
                    </button>
                  </div>
                </div>
                <div className="calendar-day-headers">
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                    <div key={day} className="calendar-day-header">{day}</div>
                  ))}
                </div>
                <div className="calendar-body">
                  {renderCalendar()}
                </div>
              </div>
            </div>

            {/* Basic Information Form */}
            <div className="basic-info-section">
            <h3 className="info-section-title">Basic Information</h3>
            <div className="info-form-container">
              <div className="form-content-wrapper">
                <div className="form-fields-container">
                  <div className="form-row">
                    <div className="form-group price-group">
                      <label className="form-label">Price ( per day)</label>
                      <span className="price-display">$10</span>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Position</label>
                      <div 
                        className="dropdown-field"
                        onClick={() => setShowPositionDropdown(!showPositionDropdown)}
                      >
                        <span>{selectedPosition}</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      {showPositionDropdown && (
                        <div className="dropdown-options">
                          {positionOptions.map((option, index) => (
                            <div 
                              key={index} 
                              className={`dropdown-option ${selectedPosition === option ? 'selected' : ''}`}
                              onClick={() => {
                                setSelectedPosition(option);
                                setShowPositionDropdown(false);
                              }}
                            >
                              {option}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">Link</label>
                      <div className="input-field">
                        <input 
                          type="text" 
                          placeholder="Link"
                          value={formData.link}
                          onChange={(e) => setFormData({...formData, link: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">From</label>
                      <div className="date-field">
                        <span>date</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.6667 2.66406H3.33333C2.59695 2.66406 2 3.26102 2 3.9974V13.3307C2 14.0671 2.59695 14.6641 3.33333 14.6641H12.6667C13.403 14.6641 14 14.0671 14 13.3307V3.9974C14 3.26102 13.403 2.66406 12.6667 2.66406Z" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10.668 1.33594V4.0026" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M5.33203 1.33594V4.0026" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 6.66406H14" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">To</label>
                      <div className="date-field">
                        <span>Date</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.6667 2.66406H3.33333C2.59695 2.66406 2 3.26102 2 3.9974V13.3307C2 14.0671 2.59695 14.6641 3.33333 14.6641H12.6667C13.403 14.6641 14 14.0671 14 13.3307V3.9974C14 3.26102 13.403 2.66406 12.6667 2.66406Z" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10.668 1.33594V4.0026" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M5.33203 1.33594V4.0026" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 6.66406H14" stroke="#6D6D6D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  
                  {/* Upload Images Section */}
                  <div className="upload-section">
                    <div className="upload-header">
                      <label className="form-label">Upload maximum 2 images.</label>
                    </div>
                    <div className="upload-container">
                      <div className="images-row">
                        {/* First Image - Small */}
                        <div className="image-card small">
                          <div className="image-preview">
                            <img src={uploadedImages[0]?.url} alt="Ad preview 1" />
                          </div>
                          <div className="image-actions">
                            <div className="action-buttons">
                              <button className="edit-btn">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect width="20" height="20" rx="4" fill="#B0C2CC" fillOpacity="0.5"/>
                                  <path d="M10 14.1172H15" stroke="#2B2B2B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                                  <path d="M12.2278 5.27796C12.4408 5.06497 12.7297 4.94531 13.0309 4.94531C13.1801 4.94531 13.3278 4.97469 13.4656 5.03177C13.6033 5.08884 13.7286 5.1725 13.834 5.27796C13.9395 5.38343 14.0231 5.50863 14.0802 5.64643C14.1373 5.78422 14.1667 5.93191 14.1667 6.08106C14.1667 6.2302 14.1373 6.37789 14.0802 6.51569C14.0231 6.65348 13.9395 6.77869 13.834 6.88415L7.14158 13.5766L5 14.112L5.53539 11.9704L12.2278 5.27796Z" stroke="#2B2B2B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </button>
                              <button className="delete-btn">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect width="20" height="20" rx="4" fill="#FF0000" fillOpacity="0.08"/>
                                  <path d="M15.5 6H13V5.5C13 5.10218 12.842 4.72064 12.5607 4.43934C12.2794 4.15804 11.8978 4 11.5 4H8.5C8.10218 4 7.72064 4.15804 7.43934 4.43934C7.15804 4.72064 7 5.10218 7 5.5V6H4.5C4.36739 6 4.24021 6.05268 4.14645 6.14645C4.05268 6.24021 4 6.36739 4 6.5C4 6.63261 4.05268 6.75979 4.14645 6.85355C4.24021 6.94732 4.36739 7 4.5 7H5V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16V7H15.5C15.6326 7 15.7598 6.94732 15.8536 6.85355C15.9473 6.75979 16 6.63261 16 6.5C16 6.36739 15.9473 6.24021 15.8536 6.14645C15.7598 6.05268 15.6326 6 15.5 6ZM8 5.5C8 5.36739 8.05268 5.24021 8.14645 5.14645C8.24021 5.05268 8.36739 5 8.5 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5V6H8V5.5ZM14 16H6V7H14V16ZM9 9.5V13.5C9 13.6326 8.94732 13.7598 8.85355 13.8536C8.75979 13.9473 8.63261 14 8.5 14C8.36739 14 8.24021 13.9473 8.14645 13.8536C8.05268 13.7598 8 13.6326 8 13.5V9.5C8 9.36739 8.05268 9.24021 8.14645 9.14645C8.24021 9.05268 8.36739 9 8.5 9C8.63261 9 8.75979 9.05268 8.85355 9.14645C8.94732 9.24021 9 9.36739 9 9.5ZM12 9.5V13.5C12 13.6326 11.9473 13.7598 11.8536 13.8536C11.7598 13.9473 11.6326 14 11.5 14C11.3674 14 11.2402 13.9473 11.1464 13.8536C11.0527 13.7598 11 13.6326 11 13.5V9.5C11 9.36739 11.0527 9.24021 11.1464 9.14645C11.2402 9.05268 11.3674 9 11.5 9C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5Z" fill="#DC3545"/>
                                </svg>
                              </button>
                            </div>
                            <span className="image-size">285x295 px</span>
                          </div>
                        </div>
                        
                        {/* Second Image - Wide */}
                        <div className="image-card wide">
                          <div className="image-preview">
                            <img src={uploadedImages[1]?.url} alt="Ad preview 2" />
                          </div>
                          <div className="image-actions">
                            <div className="action-buttons">
                              <button className="edit-btn">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect width="20" height="20" rx="4" fill="#B0C2CC" fillOpacity="0.5"/>
                                  <path d="M10 14.1172H15" stroke="#2B2B2B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                                  <path d="M12.2278 5.27796C12.4408 5.06497 12.7297 4.94531 13.0309 4.94531C13.1801 4.94531 13.3278 4.97469 13.4656 5.03177C13.6033 5.08884 13.7286 5.1725 13.834 5.27796C13.9395 5.38343 14.0231 5.50863 14.0802 5.64643C14.1373 5.78422 14.1667 5.93191 14.1667 6.08106C14.1667 6.2302 14.1373 6.37789 14.0802 6.51569C14.0231 6.65348 13.9395 6.77869 13.834 6.88415L7.14158 13.5766L5 14.112L5.53539 11.9704L12.2278 5.27796Z" stroke="#2B2B2B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </button>
                              <button className="delete-btn">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect width="20" height="20" rx="4" fill="#FF0000" fillOpacity="0.08"/>
                                  <path d="M15.5 6H13V5.5C13 5.10218 12.842 4.72064 12.5607 4.43934C12.2794 4.15804 11.8978 4 11.5 4H8.5C8.10218 4 7.72064 4.15804 7.43934 4.43934C7.15804 4.72064 7 5.10218 7 5.5V6H4.5C4.36739 6 4.24021 6.05268 4.14645 6.14645C4.05268 6.24021 4 6.36739 4 6.5C4 6.63261 4.05268 6.75979 4.14645 6.85355C4.24021 6.94732 4.36739 7 4.5 7H5V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16V7H15.5C15.6326 7 15.7598 6.94732 15.8536 6.85355C15.9473 6.75979 16 6.63261 16 6.5C16 6.36739 15.9473 6.24021 15.8536 6.14645C15.7598 6.05268 15.6326 6 15.5 6ZM8 5.5C8 5.36739 8.05268 5.24021 8.14645 5.14645C8.24021 5.05268 8.36739 5 8.5 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5V6H8V5.5ZM14 16H6V7H14V16ZM9 9.5V13.5C9 13.6326 8.94732 13.7598 8.85355 13.8536C8.75979 13.9473 8.63261 14 8.5 14C8.36739 14 8.24021 13.9473 8.14645 13.8536C8.05268 13.7598 8 13.6326 8 13.5V9.5C8 9.36739 8.05268 9.24021 8.14645 9.14645C8.24021 9.05268 8.36739 9 8.5 9C8.63261 9 8.75979 9.05268 8.85355 9.14645C8.94732 9.24021 9 9.36739 9 9.5ZM12 9.5V13.5C12 13.6326 11.9473 13.7598 11.8536 13.8536C11.7598 13.9473 11.6326 14 11.5 14C11.3674 14 11.2402 13.9473 11.1464 13.8536C11.0527 13.7598 11 13.6326 11 13.5V9.5C11 9.36739 11.0527 9.24021 11.1464 9.14645C11.2402 9.05268 11.3674 9 11.5 9C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5Z" fill="#DC3545"/>
                                </svg>
                              </button>
                            </div>
                            <span className="image-size"> 285x535 px</span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Ad Duration */}
                      <div className="ad-duration">
                        <span className="duration-label">Ad Duration:</span>
                        <div className="duration-dates">
                          <span className="date">01,03,2025</span>
                          <span className="to">to</span>
                          <span className="date">01,03,2025</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Run Ads Button */}
              <button className="run-ads-btn">
                Run Ads
              </button>
            </div>
          </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SpecialistAdsManagePage;
